module.exports = __webpack_public_path__ + "img/finsh.21ce4aff.png";